
export default {
    state: {
        curOrderLineItem: {}
    },
    mutations: {
        updateCurOrderLineItem(state, curOrderLineItem) {
            state.curOrderLineItem = curOrderLineItem
        },
    },
    getters: {

    },
    actions: {

    }
}



// WEBPACK FOOTER //
// ./src/pages/order/order.js